import { useMemo, useReducer } from "react";
import SimpleReactValidator from "simple-react-validator";

const useSimpleReactValidator = (passedOptions = {}) => {
  const [{ options }, forceUpdate] = useReducer(
    ({ options }) => ({ options }),
    {
      options: passedOptions,
    }
  );
  const simpleValidator = useMemo(() => {
    return new SimpleReactValidator(
      options.autoForceUpdate
        ? { ...options, autoForceUpdate: { forceUpdate } }
        : options
    );
  }, [options]);
  return [simpleValidator, forceUpdate];
};
export default useSimpleReactValidator;
